import React, { useEffect, useState } from 'react';
import { FxInput, FxTextarea, http, LocationSearchInput, AlertService, localstorage, formValidator, general, FxSelect } from '../../fx-core';
import './DeliveryOptions.scss';
import * as _ from 'lodash';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import dummyImage from "../../../assets/images/dummy.png";
import PhotoCapture from '../../general/PhotoCapture/PhotoCapture';
import CloseIcon from '@material-ui/icons/Close';
import { Button, Checkbox, Link, Dialog } from '@material-ui/core';

const DeliveryOptions = (props) => {
  const defaultItem = {
    imagePath: "",
    imageUrl: "",
    name: "",
    description: "",
    address: "",
    isDeliveryEnabled: false,
    isPickupEnabled: false,
    isDeliveryPartnerEnabled: 0,  // 0 = false, 1 = true
    isSelfDeliveryEnabled: 0,     // 0 = false, 1 = true
    stallOpenStatusId: -1,
    isActive: true,
    newOrderNotification: false,
    locationId: 0,
    id: props.stallId ? props.stallId : 0,
    communityId: parseInt(localstorage.getItem("communityId")),
    userId: parseInt(localstorage.getItem("userId")),
    ownerId: parseInt(localstorage.getItem("userId")),
    serviceId: props.serviceId ? props.serviceId : 0,
    stallStatusId: 1, //Pending,
    website: "",
    uengageId: 0
  };
  const defaultContext = {
    serviceName: "",
    showPayAndDeliveryOptions: false,
    isStripeConfigured: false
  };

  const [item, setItem] = useState(defaultItem);
  const [currentContext, setCurrentContext] = useState(defaultContext);
  const [stallOpenStatus, setStallOpenStatus] = useState([]);
  const [locations, setLocations] = useState([]);
  const [errors, setErrors] = useState({});
  const [isModal, setIsModal] = useState(false);
  const [photoCaptureOpen, setPhotoCaptureOpen] = useState(false);
  const [uploadConfig, setUploadConfig] = useState({});

  const initLookup = () => {
    let inputData = {
      lookups: {
        StallOpenStatus: { default: true },
        Tier4Locations: { default: true }
      },
      filters: {}
    };
    let apiOptions = {
      url: 'options/lookup',
      data: inputData
    };
    http.post(apiOptions).then(response => {
      setStallOpenStatus(response.data.StallOpenStatus);
      setLocations(response.data.Tier4Locations);
      handleItemChange({ "stallOpenStatusId": -1 });
      initMethods();
    })
  }

  const initMethods = () => {
    if (props.stallId > 0) {//Edit Stall form
      if (props.showPayAndDelivery) {
        handleCurrentContextItemChange({ "showPayAndDeliveryOptions": true });
      }
      getStallById();
    }
    else if (props.serviceId > 0) {//Create Stall form
      getServiceById();
    }
  }

  const handleInputChange = (item) => {
    handleItemChange({ [item.name]: item.value });
    item.validations = getInputValidations(item.name);
    const validationResult = formValidator.validate(item);
    const validationData = { [item.name]: validationResult };
    updateErrors(validationData);
  }

  const handleCheckbox = (event) => {
    handleItemChange({ [event.target.name]: event.target.checked });
  }

  const handleDeliveryPartnerCheckbox = (event) => {
    const value = event.target.checked ? 1 : 0;
    handleItemChange({ [event.target.name]: value });
    
    // If user unchecks delivery partner, automatically set self delivery to 1 (true)
    if (event.target.name === "isDeliveryPartnerEnabled" && !event.target.checked) {
      handleItemChange({ "isSelfDeliveryEnabled": 1 });
    }
  };

  const updateDeliveryPartnerSettings = () => {
    const inputData = {
      stallId: item.id,
      IsDeliveryPartnerEnabled: item.isDeliveryPartnerEnabled,
      IsSelfDeliveryEnabled: item.isSelfDeliveryEnabled
    };
    
    let apiOptions = {
      url: 'stall/updated/deliverypartner',
      data: inputData
    };
    
    http.post(apiOptions).then(response => {
      if (response.data.success) {
        AlertService.showSuccessMsg("Delivery partner settings updated successfully");
      } else {
        AlertService.showErrorMsg(response.data.message || "Failed to update delivery partner settings");
      }
    }).catch(error => {
      AlertService.showErrorMsg("Error updating delivery partner settings");
    });
  };

  const handleItemChange = (data) => {
    setItem(prevState => {
      return { ...prevState, ...data }
    });
  };

  const handleCurrentContextItemChange = (data) => {
    setCurrentContext(prevState => {
      return { ...prevState, ...data }
    });
  };

  //Validation area starts
  const validationMap_Item = {
    name: ["required", "maxlen"],
    address: ["required"],
    stallOpenStatusId: ["select"]
  };

  const getValidations = () => {
    let validationMap;
    validationMap = validationMap_Item;
    return validationMap;
  }

  const getInputValidations = (name) => {
    let validationMap = getValidations();
    return validationMap[name];
  }

  const bulkValidate = () => {
    let items: any = [];
    let validationMap = getValidations();
    for (var key in validationMap) {
      if (key == "name") {
        let result = { name: key, value: item[key], validations: validationMap[key], param: 25 }
        items.push(result);
      }
      else {
        let result = { name: key, value: item[key], validations: validationMap[key] }
        items.push(result);
      }
    }
    let validationResult = formValidator.bulkValidate(items);
    updateErrors(validationResult.errors);
    return validationResult.isValid;
  }

  const updateErrors = (validationData) => {
    setErrors(prevState => {
      return { ...prevState, ...validationData }
    });
  }

  const hasError = (field, validationMethod) => {
    return (
      errors &&
      errors[field] &&
      errors[field][validationMethod]
    );
  };
  //Validation area ends

  const getServiceById = () => {
    let inputData = {
      id: item.serviceId
    };
    let apiOptions: any = {
      url: `portal/service/edit/${inputData.id}`
    };
    http.get(apiOptions).then(response => {
      let result = response.data;
      handleCurrentContextItemChange({ "serviceName": response.data.serviceName });
      if (result.defaultBehaviorCode == "ItemWise") {
        handleCurrentContextItemChange({ "showPayAndDeliveryOptions": true });
      }
      else {
        handleCurrentContextItemChange({ "showPayAndDeliveryOptions": false });
      }
    });
  }

  const getStallById = () => {
    let apiOptions: any = {
      url: `stall/${item.id}`
    };
    http.get(apiOptions).then(res => {
      const result = res.data;
      result.imageUrl = general.getImageUrl(result.imagePath);
      
      // Ensure proper values for delivery partner settings
      const deliveryPartnerSettings = {
        isDeliveryEnabled: result.isDeliveryEnabled,
        isPickupEnabled: result.isPickupEnabled,
        isDeliveryPartnerEnabled: result.isDeliveryPartnerEnabled || 0,
        isSelfDeliveryEnabled: result.isSelfDeliveryEnabled || 1, // Default to 1 if null/0
        isActive: result.isActive,
        newOrderNotification: result.newOrderNotification,
        uengageId: result.uengageId || 0
      };
      
      // If uengageId is 0 or null, force isDeliveryPartnerEnabled to 0
      if (!result.uengageId || result.uengageId === 0) {
        deliveryPartnerSettings.isDeliveryPartnerEnabled = 0;
      }
      
      setItem({
        ...result,
        ...deliveryPartnerSettings
      });
      
      // Also update the item state with these settings
      handleItemChange(deliveryPartnerSettings);
    })
  }

  const addressSelected = (data) => {
    let inputData = { address: data.address, lat: data.lat, lng: data.lng };
    console.log(data);
    handleItemChange(inputData);
  };

  const saveStall = () => {
    const isValid = bulkValidate();
    if (isValid) {
      let inputData = {
        Stall: item,
        PaymentOptions: [{
          paymentOptionCode: "razorpay", //Default payment option added
          isActive: true,
          userId: item.userId
        }]
      }
      let apiOptions: any = {
        url: `stall`,
        data: inputData
      };
      http.post(apiOptions).then(res => {
        saveStallCallBack(res.data);
        // Update delivery partner settings after saving stall
        if (item.id > 0) {
          updateDeliveryPartnerSettings();
        }
      })
    }
  };

  const saveStallCallBack = (res) => {
    if (res && res.message) {
      AlertService.showErrorMsg(res.message);
      return;
    }
    AlertService.showSuccessMsg();
    if (item.id > 0) {
      props.handleDeliveryOptionsClose();
    }
    else {
      props.onFormCallBack(res);
    }
  }

  const openPhotoCapture = () => {
    let photoCaptureConfig = {
      id: item.id,
      cameraConfig: { url: `stall/savecameraimage` },
      fileUploadConfig: { url: `stall/savefileimage` }
    };
    if (item.communityId > 0) {
      photoCaptureConfig = {
        id: item.id,
        cameraConfig: { url: `stall/${item.communityId}/savecameraimage` },
        fileUploadConfig: { url: `stall/${item.communityId}/savefileimage` }
      };
    }
    setUploadConfig(photoCaptureConfig);
    setPhotoCaptureOpen(true);
  }

  const onUploadCallBack = (res: any) => {
    setPhotoCaptureOpen(false);
    if (item.id > 0) {
      getStallById();
    }
    else {
      let filePath = res.filePath;
      let imagePath = general.getImageUrl(filePath);
      handleItemChange({ "imagePath": filePath });
      handleItemChange({ "imageUrl": imagePath });
    }
  }

  const handlePhotoCaptureClose = () => {
    setPhotoCaptureOpen(false);
  }

  const handleClose = () => {
    props.handleDeliveryOptionsClose();
  }

  useEffect(() => {
    initLookup();
  }, []);

  // Check if UengageId is available (not null or 0)
  const showDeliveryPartnerOptions = item.uengageId && item.uengageId > 0;

  return (
    <div className='mystallform-ui'>
      <div className='row title-font py-1 px-2 drawer-header'>
        <span className="col-11">
          Delivery Options
        </span>
        <span className="col-1 text-center">
          <i className="fas fa-times-circle font-16 pointer" onClick={handleClose}></i>
        </span>
      </div>

      <div className='drawer-content'>
        {currentContext.showPayAndDeliveryOptions &&
          <div className='p-3'>
            <div className='font-14 bold-text pb-2'>Delivery Options</div>
            <div className='row'>
              <div className='col-6'>
                <Checkbox name="isDeliveryEnabled" color="primary" checked={item.isDeliveryEnabled} value={item.isDeliveryEnabled} onChange={handleCheckbox} />
                Delivery
              </div>
              <div className='col-6'>
                <Checkbox name="isPickupEnabled" color="primary" checked={item.isPickupEnabled} value={item.isPickupEnabled} onChange={handleCheckbox} />
                Pickup
              </div>
            </div>
            
            {/* Delivery Partner Options - Show when Delivery is enabled */}
{/* Delivery Partner Options - Show when Delivery is enabled */}
{item.isDeliveryEnabled && (
  <div className='mt-3 pt-3 border-top'>
    <div className='font-14 bold-text pb-2'>Delivery Partner Options</div>
    <div className='row'>
      {/* Show Delivery Partner checkbox ONLY if uengageId is available */}
      {showDeliveryPartnerOptions ? (
        <>
          <div className='col-6'>
            <Checkbox 
              name="isDeliveryPartnerEnabled" 
              color="primary" 
              checked={item.isDeliveryPartnerEnabled === 1} 
              value={item.isDeliveryPartnerEnabled === 1} 
              onChange={handleDeliveryPartnerCheckbox} 
            />
            Porter
          </div>
          <div className='col-6'>
            <div className='flex items-center'>
              <Checkbox 
                name="isSelfDeliveryEnabled" 
                color="primary" 
                checked={item.isSelfDeliveryEnabled === 1} 
                value={item.isSelfDeliveryEnabled === 1} 
                disabled={true}
                style={{ cursor: 'not-allowed' }}
              />
              Self Delivery
              <span className='ml-1 text-gray-500 text-sm'>(Default)</span>
            </div>
          </div>
        </>
      ) : (
        /* When no uengageId, show only Self Delivery taking full width */
        <div className='col-12'>
          <div className='flex items-center'>
            <Checkbox 
              name="isSelfDeliveryEnabled" 
              color="primary" 
              checked={item.isSelfDeliveryEnabled === 1} 
              value={item.isSelfDeliveryEnabled === 1} 
              disabled={true}
              style={{ cursor: 'not-allowed' }}
            />
            Self Delivery
            <span className='ml-1 text-gray-500 text-sm'>(Default)</span>
          </div>
        </div>
      )}
    </div>
  
  </div>
)}
          </div>
        }
      </div>
      <div className='px-4 py-2 drawer-footer'>
        <Button color="primary" variant="contained" fullWidth className='btn-style' onClick={saveStall}><b>Save</b></Button>
      </div>
      <Dialog
        open={photoCaptureOpen}
        onClose={handlePhotoCaptureClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <PhotoCapture uploadConfig={uploadConfig} onUploadCallBack={onUploadCallBack} handlePhotoCaptureClose={handlePhotoCaptureClose} />
      </Dialog>
    </div>
  );
}
export default DeliveryOptions;